export default "__VITE_ASSET__B9tZ3AcR__"